import React from "react";
import RetailSettingsGenericSkeleton from "./RetailSettingsGenericSkeleton";

function RetailSettingsDetailSkeleton() {
  return (
    <>
      <RetailSettingsGenericSkeleton />
    </>
  );
}

export default RetailSettingsDetailSkeleton;
